import { Props } from '@/pages/platform/product-detail'
import useIsMobile from '@/hooks/useIsMobile'
import dynamic from 'next/dynamic'

const PC = dynamic(() => import('@/pages/platform/product-detail'))
const Mobile = dynamic(() => import('@/mobile-pages/product-detail'))

const ProductDetail = (props: Props) => {
  return useIsMobile() ? <Mobile {...props} /> : <PC {...props} />
}

export { getServerSideProps } from '@/pages/platform/product-detail'

export default ProductDetail
